export default {
  // 新增设备台账
  insertPaEquipmentLedger: '/ygsjzs/paEquipmentLedger/insertPaEquipmentLedger',
  // 修改设备台账
  updatePaEquipmentLedger: '/ygsjzs/paEquipmentLedger/updatePaEquipmentLedger',
  // 删除设备台账
  deletePaEquipmentLedger: '/ygsjzs/paEquipmentLedger/deletePaEquipmentLedger',
  // 查询设备台账详情

  selectPaEquipmentLedgerByRecordId: '/ygsjzs/paEquipmentLedger/selectPaEquipmentLedgerByRecordId',

  // 分页查询设备台账列表
  selectPaEquipmentLedgerByPage: '/ygsjzs/paEquipmentLedger/selectPaEquipmentLedgerByPage'

}
